import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import * as S from './styled';
export const FlashMessage = ({
  message,
  duration,
  color
}) => {
  const [isVisible, setIsVisible] = useState(true);
  useEffect(() => {
    const timeout = window.setTimeout(() => {
      setIsVisible(false);
    }, duration);
    return () => {
      window.clearTimeout(timeout);
    };
  }, [duration]);
  return /*#__PURE__*/React.createElement(S.Container, null, /*#__PURE__*/React.createElement(S.Message, {
    isVisible: isVisible,
    color: color
  }, message));
};
FlashMessage.defaultProps = {
  duration: 3000
};
FlashMessage.propTypes = {
  message: PropTypes.string.isRequired,
  duration: PropTypes.number,
  color: PropTypes.string
};